<form [formGroup]="baseHeightForm">
  <div fxLayout="row" fxLayoutGap="4px">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label i18n>BASE</mat-label>
      <input matInput formControlName="base">
      <mat-hint i18n>Horizontal number of ducts</mat-hint>
      <mat-error *ngIf="baseHeightForm.get('base').invalid" i18n>Must be equals or less than 16</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex>
      <mat-label i18n>HEIGHT</mat-label>
      <input matInput formControlName="height">
      <mat-hint i18n>Vertical number of ducts</mat-hint>
      <mat-error *ngIf="baseHeightForm.get('height').invalid" i18n>Must be equals or less than 8</mat-error>
    </mat-form-field>
  </div>
</form>

<form [formGroup]="form">

  <div class="installation-base">
    <h5 i18n>INSTALLATION BASE</h5>
    <mat-button-toggle-group formControlName="installation_base">
      <mat-button-toggle value="soil" i18n>SOIL</mat-button-toggle>
      <mat-button-toggle value="concret" i18n>CONCRET</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div fxLayout="row" fxLayoutGap="4px">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label i18n>DUCT DIAMETER</mat-label>
      <input matInput formControlName="duct_diameter">
      <mat-hint>mm</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex>
      <mat-label i18n>SUBDUCT DIAMETER</mat-label>
      <input matInput formControlName="subduct_diameter">
      <mat-hint>mm</mat-hint>
    </mat-form-field>
  </div>
</form>
<ng-container *ngFor="let ductArrayForm of ductArrayForms.controls; let i = index">
  <h4 class="duct-title" i18n>BASE {{i + 1 | number}}</h4>
  <div class="duct-content">
    <mat-accordion class="duct-accordion">
      <mat-expansion-panel *ngFor="let ductForm of ductArrayForm.controls; let y = index">
        <mat-expansion-panel-header>
          <mat-panel-title i18n>
            DUCT {{i + 1}} - {{y + 1}}
          </mat-panel-title>
          <mat-panel-description>
            <ng-container *ngIf="ductForm.valid else errorIconBlock">
              {{getDuctPanelDescription(ductForm)}}
            </ng-container>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div>

          <form [formGroup]="ductForm" fxLayout="row" fxLayoutGap="4px">
            <div fxFlex>
              <mat-slide-toggle formControlName="has_subducts" (change)="changeHasSubducts(ductForm, $event.checked)"
                i18n>
                With subducts
              </mat-slide-toggle>
            </div>
            <div *ngIf="!ductForm.value.has_subducts">
              <mat-slide-toggle formControlName="occupied" i18n>Occupied</mat-slide-toggle>
            </div>
            <div *ngIf="ductForm.value.has_subducts">
              <mat-button-toggle-group [value]="ductForm.value.subducts.length"
                (change)="changeSubducts(ductForm, $event.value)">
                <mat-button-toggle [value]="1">1</mat-button-toggle>
                <mat-button-toggle [value]="2">2</mat-button-toggle>
                <mat-button-toggle [value]="3">3</mat-button-toggle>
                <mat-button-toggle [value]="4">4</mat-button-toggle>
                <mat-button-toggle [value]="7">7</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </form>

          <ng-container *ngIf="ductForm.value.has_subducts">
            <ng-container *ngFor="let subductForm of getSubductForms(ductForm); let z = index">
              <form [formGroup]="subductForm" fxLayout="row" fxLayoutGap="4px">
                <div i18n fxFlex>SUBDUCT {{z + 1 | number}}</div>
                <mat-slide-toggle formControlName="occupied" i18n>Occupied</mat-slide-toggle>
              </form>
            </ng-container>
          </ng-container>

        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</ng-container>

<ng-template #errorIconBlock>
  <mat-icon color="warn">error</mat-icon>
</ng-template>
